import React, { useState, useEffect } from "react";
import { Line, Bar, Doughnut, Pie, Scatter } from "react-chartjs-2";
import "../MasterDashboard.css";
import axios from "axios";
import { Form, Button } from "react-bootstrap";
import Select from "react-select";
import { environment } from "../../../environment";
import MapComponent from "../AdminMap";
import MasterMap from "../MasterMap";
import Spinner from "../../Components/Spinner";
import withReactContent from "sweetalert2-react-content";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { componentDidMount } from "react-google-maps/lib/utils/MapChildHelper";
import Swal from "sweetalert2";
const { SearchBar } = Search;
const MySwal = withReactContent(Swal);

const AgentDashboard = ({ history }) => {
  const [tenantsCount, setTenantsCount] = useState(0);
  const [customerCount, setCustomerCount] = useState(0);
  const [deviceCount, setDeviceCount] = useState(0);
  const [activeCount, setActiveCount] = useState(0);
  const [inActiveCount, setInActiveCount] = useState(0);
  const [deviceCoordinate, setDeviceCoordinate] = useState([]);
  const [isMapToCalled, setIsMapToCalled] = useState(false);
  const [location, setLocation] = useState([]);
  const [locationType, setLocationType] = useState("");
  const [callMap, setCallMap] = useState(false);
  const [devicePerLocation, setdevicePerLocation] = useState([]);
  const [value, setValue] = useState([]);
  const [response, setRes] = useState([]);
  let details = localStorage.getItem("userDetails");
  let location_array = [];
  location_array = [
    {
      locationName: "All",
      locationId: 10,
    },
    {
      locationName: "Hospital",
      locationId: 1,
    },
    {
      locationName: "School",
      locationId: 2,
    },
    {
      locationName: "Office",
      locationId: 3,
    },
    {
      locationName: "Hospitality",
      locationId: 4,
    },
  ];
  // let intransit = 0;

  useEffect(() => {
    let activeDevice = [];
    let inActiveDevice = [];
    let dap_device_coordinates = [];
    let details = JSON.parse(localStorage.getItem("partnerDetails"));
    console.log("hello", details);

    axios
      .get(
        environment.dap_url +
          "shipmentApi/getByConsigneeStatesData?consigneeId=" +
          details._id
      )
      // .then((response) => response.json())
      // console.log(response);
      .then((res) => {
        console.log("hello");
        console.log(res.data);
        setRes(res.data);

        // setRes(details.data.id.id);
        // let intransit = res.data[0].count;
      })
      .catch((err) => {
        console.log(err);
        MySwal.fire({
          title: <p>{err?.response?.data?.message}</p>,
          type: "error",
        });
      });
    //   .catch((err) => {});

    // axios
    //   .get(environment.dap_url + "dapDevice/getAll")
    //   .then((res) => {
    //     console.log(res);

    //     setDeviceCount(res.data.length);
    //     // console.log("fruit", res.data.length);
    //     //setDeviceCoordinate(res.data);
    //     setDeviceLocation(res.data);
    //     res.data.forEach(function (item) {
    //       if (item.isActive == true) {
    //         // console.log("active");
    //         activeDevice.push(item.deviceName);
    //         // console.log(activeDevice);
    //         setActiveCount(activeDevice.length);
    //       }

    //       if (item.isActive == false) {
    //         inActiveDevice.push(item.deviceName);
    //         //console.log(inActiveDevice);
    //         setInActiveCount(inActiveDevice.length);
    //       }
    //     });
    //   })
    //   .catch((err) => {});

    // axios
    //   .post(environment.dap_url + "users/getUsersByfilters", {
    //     filters: {},
    //   })
    //   .then((res) => {
    //     // console.log(res.data);

    //     console.log(res.data.length);
    //     setCustomerCount(res.data.length);
    //   })
    //   .catch((err) => {});

    // axios
    //   .get(
    //     environment.apiUrl +
    //       "tenantInfos?pageSize=100&page=0&sortProperty=createdTime&sortOrder=DESC",
    //     {
    //       headers: {
    //         "X-Authorization": "Bearer " + localStorage.getItem("token"),
    //       },
    //     }
    //   )
    //   .then((res) => {
    //     console.log(res.data.data);
    //     setTenantsCount(res.data.data.length);
    //   })
    //   .catch((err) => {});
  }, []);
  useEffect(() => {
    // console.log("ananya");
    console.log("dap", response[0]);
    //intransit = response[0][0].count;
  }, [response]);
  // const _id = [0, 1, 2];
  // console.log(_id);
  // const count = [];
  let initialized = 0;
  let intransit = 0;
  let received = 0;
  let completed = 0;
  let count = 0;
  let i = 0;
  for (i = 0; i <= response.length; i++) {
    if (response[i]?._id == 0) {
      initialized = response[i]?.count;
    } else if (response[i]?._id == 1) {
      intransit = response[i]?.count;
    } else if (response[i]?._id == 2) {
      received = response[i]?.count;
    } else if (response[i]?._id == 3) {
      completed = response[i]?.count;
    }
  }
  const columns = [
    {
      dataField: "deviceName",
      text: "Device",
      sort: true,
    },
  ];

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ];

  return (
    <div style={{ marginTop: "5%", marginLeft: "2%" }}>
      <div className="row">
        <div className="col-md-6 col-lg-3 grid-margin stretch-card">
          <div className="card-md">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-md-center">
                <i className="mdi mdi-account-multiple icon-lg text-success"></i>
                <div className="ml-3">
                  <p className="mb-0">Initialized</p>
                  <p>{initialized}</p>
                  {/* <div> {response == 3 ? count[0] : count[""]}</div> */}
                  {/* <p>{response.length ? response[0].count : 0}</p> */}
                  {/* <p>{intransit ? intransit : 0}</p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-3 grid-margin stretch-card">
          <div className="card-md">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-md-center">
                <i className="mdi mdi-polaroid icon-lg text-success"></i>
                <div className="ml-3">
                  <p className="mb-0">In transit</p>
                  <p>{intransit}</p>
                  {/* <div> {_id == 1 ? count[""] : count[1]}</div> */}
                  {/* <p>{response.length ? response[1].count : 1}</p> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6 col-lg-3 grid-margin stretch-card">
          <div className="card-md">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-md-center">
                <i className="mdi mdi-settings icon-lg text-success"></i>
                <div className="ml-3">
                  <p className="mb-0">Received</p>
                  <p>{received}</p>
                  {/* <div> {_id == 1 ? count[""] : count[2]}</div> */}
                  {/* <p>{response.length ? response[2].count : 2}</p> */}
                  {/* <h6>Rules</h6> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6 col-lg-3 grid-margin stretch-card">
          <div className="card-md">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-md-center">
                <i className="mdi mdi-settings icon-lg text-success"></i>
                <div className="ml-3">
                  <p className="mb-0">Completed</p>
                  <p>{completed}</p>
                  {/* <div> {_id == 1 ? count[""] : count[2]}</div> */}
                  {/* <p>{response.length ? response[2].count : 2}</p> */}
                  {/* <h6>Rules</h6> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentDashboard;
